import { useShallow } from 'zustand/shallow';
import type { SimInventoryState } from './types';
import useSimInventoryStore from './useSimInventoryStore';

const useSimInventoryStoredFilters = () =>
  useSimInventoryStore(useShallow((state: SimInventoryState) => state.filters));

export default useSimInventoryStoredFilters;
